import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('shares');
const type = createActionType('shares');

export const GET_SHARED_OUTPUTS_FOR_PROJECT = apiType('GetSharedOutputsForProject');
export const PAUSE_SCHEDULE = apiType('PauseSchedule');
export const DELETE_SCHEDULE = apiType('DeleteSchedule');

export const OPEN_SCHEDULE_EMAIL_DIALOG = type('OpenScheduleEmailDialog');
export const CLOSE_SCHEDULE_MAIL_DIALOG = type('CloseScheduleMailDialog');
export const GET_TRANSFORMATION_EMAIL_SCHEDULE = apiType('GetTransformationEmailSchedule');
export const SET_TRANSFORMATION_EMAIL_SCHEDULE = apiType('SetTransformationEmailSchedule');
export const SET_EXPLORATION_EMAIL_SCHEDULE = apiType('SetExplorationEmailSchedule');
export const SEND_EMAIL = apiType('SendEmail');

export const OPEN_SCHEDULE_SHEET_DIALOG = apiType('OpenScheduleSheetDialog');
export const CLOSE_SCHEDULE_SHEET_DIALOG = type('CloseScheduleSheetDialog');
export const SAVE_SHEET_SCHEDULE = apiType('SaveSheetSchedule');

export const SYNC_NOW = apiType('SyncNow');
